import "@mantine/core/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/notifications/styles.css";
import "./styles.css";

import { createTheme, MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const theme = createTheme({
  primaryColor: "ink",
  primaryShade: 9,
  defaultRadius: "xs",
  fontFamily: "'Avenir Next', Avenir, 'Noto Sans SC', 'Helvetica Neue', Arial, sans-serif",
  fontFamilyMonospace: "'SFMono-Regular', Consolas, 'Liberation Mono', monospace",
  headings: {
    fontFamily: "'Iowan Old Style', 'Songti SC', 'Noto Serif SC', Georgia, serif",
    fontWeight: "500",
  },
  colors: {
    ink: ["#faf9f5", "#f5f4ed", "#e8e6dc", "#d1cfc5", "#b0aea5", "#87867f", "#5e5d59", "#3d3d3a", "#262624", "#141413"],
    terracotta: ["#fdf6f2", "#f9ebe4", "#f3ddd3", "#ebc5b5", "#d97757", "#cf6847", "#c05a3c", "#9d4632", "#7c382b", "#5b2b23"],
    gray: ["#faf9f5", "#f5f4ed", "#e8e6dc", "#d1cfc5", "#b0aea5", "#87867f", "#5e5d59", "#3d3d3a", "#262624", "#141413"],
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="top-right" />
      <App />
    </MantineProvider>
  </StrictMode>,
);
